var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.$store.state.dark ? "grey darken-4" : "grey lighten-4",attrs:{"dark":_vm.$store.state.dark}},[_c('Navbar'),_c('Snackbar'),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }